import { convertValues } from '~/util';

import { client } from './client/Client';

export interface CardProgram {
  id: string;
  bin: string;
  cardProgramType: string;
  primaryCardScheme: string;
  description?: string;
  status: string;
  createdAt: Date;
}

interface ListCardProgramsResponse {
  cardPrograms: CardProgram[];
  hasMore: boolean;
}

export class CardProgramRepository {
  static async get(id: string): Promise<CardProgram> {
    return client.get<unknown, CardProgram>(`/cards/programs/${id}`).then((response) => {
      const program = convertValues<CardProgram>(response, undefined, { bin: (response as any).bin });
      const rawDate = (response as any).createdAt || (response as any).created_at;
      if (rawDate && (typeof program.createdAt === 'string' || !program.createdAt)) {
        program.createdAt = new Date(rawDate);
      }
      return program;
    });
  }

  static async listCardPrograms(): Promise<ListCardProgramsResponse> {
    try {
      return await client.get<unknown, ListCardProgramsResponse>('/cards/programs').then((response) => ({
        cardPrograms: Array.isArray(response?.cardPrograms)
          ? response.cardPrograms.map((e) => {
              const program = convertValues<CardProgram>(e, undefined, { bin: e.bin });
              // Ensure createdAt is a Date even if it came back as a string or with unexpected key mapping
              const rawDate = (e as any).createdAt || (e as any).created_at;
              if (rawDate && (typeof program.createdAt === 'string' || !program.createdAt)) {
                program.createdAt = new Date(rawDate);
              }
              return program;
            })
          : [],
        hasMore: Boolean(response?.hasMore),
      }));
    } catch (error) {
      console.error('Failed to fetch card programs:', error);
      return { cardPrograms: [], hasMore: false };
    }
  }
}
